module.exports = __webpack_public_path__ + "assets/img/qingnengyuan.784edbdc.png";